<template>
  <div class="wf--ml-16 wf-absolute wf-bg-white wf-rounded-lg wf-overflow-hidden wf-border wf-shadow-md wf-w-32 wf-z-50">
    <ul>
      <li class="wf-px-4" v-for="availableColumn in availableColumns" :key="availableColumn.text">
        <a
          @click.prevent="updateColumns(availableColumn.classes)"
          class="wf-w-full wf-inline-block wf-py-1 wf-text-black wf-text-xs"
          href="#"
          v-text="availableColumn.text"
        ></a>
      </li>
    </ul>
  </div>
</template>

<script>
  import { ColumnFactory } from '../../factories/ColumnFactory'
  import ArrayManipulation from '../../mixins/ArrayManipulation'
  export default {
    mixins: [ArrayManipulation],
    props: {
      parentModule: {
        type: String,
        required: false,
      },
      parent: {
        type: Object,
        required: true
      }
    },
    computed: {
      pageComponentIndex() {
        return this.parent.pageComponentIndex
      },
      sectionIndex() {
        return this.parent.sectionIndex
      },
      rowIndex() {
        return this.parent.rowIndex
      },
      columnIndex() {
        return this.parent.columnIndex
      },
      componentIndex() {
        return this.parent.componentIndex
      },
      componentSectionIndex() {
        return this.parent.componentSectionIndex
      },
      componentRowIndex() {
        return this.parent.componentRowIndex
      },
      element() {
        let element = {
          pageComponent: this.pageComponentIndex,
          section: this.sectionIndex,
          row: this.rowIndex,
          column: this.columnIndex,
          component: this.componentIndex,
          componentSection: this.componentSectionIndex,
          componentRow: this.componentRowIndex,
        }

        if (this.parentModule === 'layoutPageComponentModule') {
          element = {
            layoutPageComponent: this.pageComponentIndex,
            section: this.sectionIndex,
            row: this.rowIndex,
            column: this.columnIndex,
            component: this.componentIndex,
            componentSection: this.componentSectionIndex,
            componentRow: this.componentRowIndex,
          }
        }
        return element
      },
      availableColumns() {
        return [
          {
            text: '1/1',
            classes: {
              phone: [['WIDTH_12_12']],
              tablet: [['WIDTH_12_12']],
              desktop: [['WIDTH_12_12']],
            }
          },
          {
            text: '1/2 + 1/2',
            classes: {
              phone: [['WIDTH_12_12'], ['WIDTH_12_12']],
              tablet: [['WIDTH_6_12'], ['WIDTH_6_12']],
              desktop: [['WIDTH_6_12'], ['WIDTH_6_12']],
            }
          },
          {
            text: '2/3 +  1/3',
            classes: {
              phone: [['WIDTH_12_12'], ['WIDTH_12_12']],
              tablet: [['WIDTH_8_12'], ['WIDTH_4_12']],
              desktop: [['WIDTH_8_12'], ['WIDTH_4_12']],
            }
          },
          {
            text: '1/3 + 1/3 +  1/3',
            classes: {
              phone: [['WIDTH_12_12'], ['WIDTH_12_12'], ['WIDTH_12_12']],
              tablet: [['WIDTH_4_12'], ['WIDTH_4_12'], ['WIDTH_4_12']],
              desktop: [['WIDTH_4_12'], ['WIDTH_4_12'], ['WIDTH_4_12']],
            }
          },
          {
            text: '1/2 + 1/4 +  1/4',
            classes: {
              phone: [['WIDTH_12_12'], ['WIDTH_12_12'], ['WIDTH_12_12']],
              tablet: [['WIDTH_4_12'], ['WIDTH_4_12'], ['WIDTH_4_12']],
              desktop: [['WIDTH_6_12'], ['WIDTH_3_12'], ['WIDTH_3_12']],
            }
          },
        ]
      },
      columns(){
        return this.$store.getters['componentColumnModule/elements'](this.element, this.parentModule)
      },
    },
    methods: {
      addColumns(qty = 1) {
        this.addToArray('componentRowModule', this.newColumns(qty), 'columns', null, {}, true, this.parentModule)
      },
      updateColumns(devicesClasses) {
        Object.keys(devicesClasses).forEach(device => {
          let newColumns = devicesClasses[device]
          newColumns.forEach((classes, index) => {
            classes = classes.map(columnWidthClass => new Object({property: 'ColumnWidth', value:columnWidthClass, touched: false}))
            if (this.columns[index]) {
              return this.addToArray('componentColumnModule', classes, 'containerClasses', device, {componentColumn: index}, true, this.parentModule)
            }
            this.addColumns()
            return this.addToArray('componentColumnModule', classes, 'containerClasses', device, {componentColumn: index}, true, this.parentModule)
          })
          if (newColumns.length >= this.columns.length) {
            return
          }
          let columnsToRemove = this.columns.length - newColumns.length
          for (let x = 0; x < columnsToRemove; x++) {
            this.removeFromArray('componentRowModule', [this.columns[this.columns.length - 1]], 'columns', null, {}, true, this.parentModule)
          }
        })
      },
      newColumns(qty = 1) {
        return (new ColumnFactory(qty)).create()
      }
    },
  }
</script>